import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import useStyles from './UspImage.styles';
import Image from 'next/image';
const UspImage = (props) => {
    const { image } = props;
    const { classes } = useStyles();
    return (_jsx(_Fragment, { children: (image === null || image === void 0 ? void 0 : image.url) && (_jsx("div", { className: classes.container, children: _jsx(Image, { className: classes.image, src: image.url, alt: (image === null || image === void 0 ? void 0 : image.altText) && image.altText, width: 75, height: 75, loading: "lazy" }) })) }));
};
export default UspImage;
